module.exports = __webpack_public_path__ + "static/media/orderAndCart_submitOrder.f51b746d.png";